import axios from 'axios'

const sendCognitoPasswordResetEmail = async (email) => {
  await axios.post('https://w2zgeuzzgg.execute-api.us-west-2.amazonaws.com/prod/send-password-reset-email',
    {
      email: email.toLowerCase()
    }
  )
}

export default sendCognitoPasswordResetEmail
